import { render, staticRenderFns } from "./ShipmentManagement.vue?vue&type=template&id=fb8c6596&lang=pug"
import script from "./ShipmentManagement.vue?vue&type=script&lang=js"
export * from "./ShipmentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports